import { useState } from 'react';
import { glossary } from '../../../mocks/glossary';

export default function GlossarySection() {
  const [openId, setOpenId] = useState<number | null>(null);

  return (
    <section className="py-20 px-4 bg-gradient-to-r from-[#1a1a1f] via-[#242429] to-[#1a1a1f]">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12 animate-on-scroll opacity-0">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">Глоссарий терминов казино</h2>
          <p className="text-gray-400">Основные понятия и термины live-игр</p>
        </div>

        <div className="space-y-4">
          {glossary.map((item, index) => (
            <div 
              key={item.id} 
              className="bg-[#242429] rounded-2xl overflow-hidden hover:shadow-xl hover:shadow-[#d4af37]/10 transition-all duration-300 animate-on-scroll opacity-0"
              style={{ animationDelay: `${index * 50}ms` }}
            >
              <button
                onClick={() => setOpenId(openId === item.id ? null : item.id)}
                className="w-full px-6 py-4 flex items-center justify-between text-left hover:bg-[#1a1a1f] transition-colors"
              >
                <span className="text-lg font-bold text-white">{item.term}</span>
                <i className={`${openId === item.id ? 'ri-subtract-line' : 'ri-add-line'} text-2xl text-[#d4af37] transition-transform duration-300`}></i>
              </button>
              
              {openId === item.id && (
                <div className="px-6 pb-4 animate-fade-in">
                  <p className="text-gray-300 leading-relaxed">{item.definition}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}